import * as React from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Alert from '@mui/material/Alert';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { useState } from 'react';
import { useAuth } from '../../utils/AuthContext.js';
import { useNavigate, Link } from 'react-router-dom';
import NavBar from '../../components/AttendeeNavBar.js';
import PasswordField from '../../components/Password.js';

function Copyright(props) {
  return (
    <Typography
      variant="body2"
      color="text.secondary"
      align="center"
      {...props}
    >
      {'Copyright © '}
      <Link color="inherit" to="/student/login">
        University of Michigan-Dearborn
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

// TODO remove, this demo shouldn't need to reset the theme.

const defaultTheme = createTheme();

export default function StudentLogin() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const { login, loginError, logout } = useAuth();
  const navigate = useNavigate();
  const { user } = useAuth();

  const handleSubmit = async (event) => {
    event.preventDefault();
    const u = await login({ email: email?.toLowerCase() ?? email, password });
    if (u) {
      if (u.success && u.data.role === 'STUDENT') {
        if (u.data.projectsOwned.length === 0) {
          navigate('/student/dashboard/project/0');
          return;
        }
        navigate(`/student/dashboard/project/${u.data.projectsOwned[0]._id}`);
        return;
      }
      if (u?.success) await logout();
      return;
    }
  };

  const invalidInput = () => {
    if (email.length > 40 || password.length > 40) {
      return true;
    }

    if (email.length === 0 || password.length === 0) {
      return true;
    }

    return false;
  };

  React.useEffect(() => {
    if (user) {
      if (user.role === 'STUDENT') {
        if (user.projectsOwned.length === 0) {
          navigate('/student/dashboard/project/0');
          return;
        }
        navigate(`/student/dashboard/project/${user.projectsOwned[0]._id}`);
        return;
      }
    }
  }, [user]);

  return (
    <ThemeProvider theme={defaultTheme}>
      <NavBar />
      <Container component="main" maxWidth="xs">
        <CssBaseline />

        <Box
          sx={{
            marginTop: 11,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            Student Sign in
          </Typography>
          {loginError && (
            <Alert severity="error" sx={{ my: 3 }}>
              {loginError}
            </Alert>
          )}
          <Box
            component="form"
            onSubmit={handleSubmit}
            noValidate
            sx={{ mt: 1 }}
          >
            <TextField
              margin="normal"
              required
              fullWidth
              id="email"
              label="Email Address"
              name="email"
              autoComplete="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoFocus
            />
            <PasswordField
              margin="normal"
              required
              fullWidth
              name="password"
              label="Password"
              id="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />

            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
              disabled={!!invalidInput()}
            >
              Sign In
            </Button>
            <Grid container>
              <Grid item xs>
                <Link to="/password/forgot" variant="body2">
                  Forgot password?
                </Link>
              </Grid>
              <Grid item>
                <Link to="/student/verify" variant="body2">
                  {"Don't have an account? Sign Up"}
                </Link>
              </Grid>
            </Grid>
          </Box>
        </Box>
        <Copyright sx={{ mt: 8, mb: 4 }} />
      </Container>
    </ThemeProvider>
  );
}
